import styled from "styled-components";
import { maxWindowSize } from "../lib/global-styles";

const Container = styled.div`
  max-width: ${(props) => (props.maxWindowSize || maxWindowSize) + "px"};
  margin: 0 auto;
  padding: 10px;
`;
export default Container;
